import * as fs from 'fs'
import { archiveFolderToBase64 } from '../utils/zip'
import { getCommitInfo } from '../utils/git'
import { sanitizeDescription } from '../utils/description'
import { type DeployOptions } from '../index'
import { createFunctionContext, waitForFunctionActive } from './scf'

/**
 * 部署云函数
 * @param directory 本地代码目录
 * @param options 部署选项
 */
export async function deploy(directory: string, options: DeployOptions) {
  if (!fs.existsSync(directory)) {
    throw new Error('Directory not found.')
  }

  const context = createFunctionContext(options)

  const base64 = await archiveFolderToBase64({
    entry: directory
  })

  console.log('Start deploying...')

  // 更新函数代码
  console.log('Start updating function code...')

  await waitForFunctionActive(context)

  const updateFunctionCodeResponse = await context.client.UpdateFunctionCode({
    FunctionName: options.functionName,
    Namespace: options.namespace,
    ZipFile: base64
  })

  console.log('UpdateFunctionCode', updateFunctionCodeResponse.RequestId)

  await waitForFunctionActive(context)

  // 发布版本
  console.log('Start publishing version...')

  const [hash, msg] = getCommitInfo()
  const description = sanitizeDescription([hash, msg].join(' '))

  const publishVersionResponse = await context.client.PublishVersion({
    FunctionName: options.functionName,
    Namespace: options.namespace,
    Description: description
  })

  console.log('PublishVersion', publishVersionResponse)

  if (!publishVersionResponse.FunctionVersion) {
    throw new Error('PublishVersion did not return a function version')
  }

  await waitForFunctionActive(context)

  console.log('Deploy finished.')

  return {
    functionVersion: publishVersionResponse.FunctionVersion,
    requestId: publishVersionResponse.RequestId
  }
}
